<template>
  <div style="padding-bottom: 64px;">
    <van-nav-bar
      title="求职意向"
      left-arrow
      fixed
      placeholder
      @click-left="onClickLeft">
    </van-nav-bar>
    <div class="form">
      <van-cell-group class="form-cont">
        <van-field
          input-align="right"
          v-model="detail.positionCategoryName"
          placeholder="请输入期望职位"
          label="期望职位">
        </van-field>

        <van-field
          input-align="right"
          v-model="detail.tradesName"
          placeholder="请输入期望行业"
          label="期望行业">
        </van-field>

        <van-field
          input-align="right"
          readonly
          @click="showPicker = true"
          is-link
          placeholder="请选择工作区域"
          clickable
          v-model="detail.areaName"
          label="工作区域" />

        <van-field
          input-align="right"
          readonly
          @click="showPicker = true"
          is-link
          label="期望薪资">
          <template #input>
            <div class="picker-cont">
              5000-8000
            </div>
          </template>
        </van-field>

        <van-field
          input-align="right"
          readonly
          @click="showPicker = true"
          is-link
          label="工作性质">
          <template #input>
            <div class="picker-cont">
              全职
            </div>
          </template>
        </van-field>

      </van-cell-group>
    </div>

    <div class="fixed-bottom">
      <van-button type="primary" class="btn-org-border" color="#FFF9F9" round>删 除</van-button>
      <van-button type="primary" class="btn-blue" color="linear-gradient(to right top, #2F72F6,#1C54CF)" round>保 存</van-button>
    </div>

    <!--选择生日-->
    <van-popup v-model="showPicker" position="bottom" style="width: 100%;">
      <van-picker
        show-toolbar
        :columns="columns"
        @cancel="showPicker = false"
        @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'intention',
  data() {
    return {
      detail: {},
      wanted: '行政专员',
      columns: ['杭州', '宁波', '温州', '绍兴', '湖州', '嘉兴', '金华', '衢州'],
      showPicker: false
    }
  },
  methods: {
    onload(id) {
      this.module.api.intentionDetail({
        data: { id },
        success: (res) => {
          this.detail = res
        }
      })
    },
    onClickLeft() {
      this.$router.go(-1)
    },
    onConfirm(value) {
      this.value = value;
      this.showPicker = false;
    }
  },
  mounted() {
    this.$route.query.id && this.onload(this.$route.query.id)
  }
}
</script>

<style lang="less" scoped>
  .user-img{
    position: relative;
    width: 88px;
    margin:20px auto 40px;
    img{
      width: 88px;
      height: 88px;
    }
    i{
      position: absolute;
      right:0;
      top:0;
      color:#2F72F6;
      font-size: 22px;
    }
  }
  /deep/.van-cell{
    padding:20px 16px;
  }
  /deep/.van-hairline--top-bottom::after,/deep/.van-hairline-unset--top-bottom::after{
    display: none;
  }
  /deep/.van-cell__right-icon{
    transform: rotate(90deg);
    top:-4px;
  }
  .fixed-bottom{
    padding:10px 16px 20px;
    button{
      flex:2;
    }
    .btn-org-border{
      border:1px solid #FF5945!important;
      box-shadow: none;
      margin-right: 16px;
      flex:1;
      color:#FF5945;
      .van-button__text{
        color:#FF5945;
      }
    }
  }
</style>
